@use "../../../../../../../src/styles/Constants.scss" as Constants;
@use "../../../../../../../src/styles/Colors.scss" as Colors;

.container {
	width: 100%;
}

.field {
	display: flex;
	flex-direction: row;
}

.filterCheckboxContainer {
	display: flex;
	align-items: start;
	margin-top: - Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
}

.white {
	background-color: Colors.$col-white;
}